import PropTypes from 'prop-types';
import React, {Component} from 'react';

//lodash
import invoke from 'lodash/invoke';

//helpers
import {styleable} from 'decorators';
import {findScrollParent, getScrollBottom} from 'utils/dom-utils';

//components
import Spinner from 'components/Spinner';

//styles
import {InfiniteScroll} from './styles';

@styleable
class InfiniteScrollComponent extends Component {
  static defaultProps = {
    spinnerSize: '2rem',
    threshold: 0
  };

  static propTypes = {
    /**
     * 1. Shows or hides the spinner
     * 2. When updates to false, the component re-checks itself to whether
     *    trigger onBottom callback once again.
     */
    isLoading: PropTypes.bool,
    onBottom: PropTypes.func,
    spinnerSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]),
    threshold: PropTypes.number
  };

  hostElement = null;
  scrollParentElement = null;

  componentDidMount() {
    this.scrollParentElement = findScrollParent(this.hostElement) || window;
    this.scrollParentElement.addEventListener('scroll', this.check);
    this.asyncCheck();
  }

  componentDidUpdate(prevProps) {
    const {isLoading} = this.props;

    if (prevProps.isLoading !== isLoading) {
      this.asyncCheck();
    }
  }

  componentWillUnmount() {
    this.scrollParentElement.removeEventListener('scroll', this.check);
  }

  asyncCheck = () => setTimeout(this.check, 0);

  check = () => {
    const {isLoading, threshold} = this.props;
    if (isLoading) {
      return;
    }
    if (getScrollBottom(this.scrollParentElement) <= threshold) {
      invoke(this.props, 'onBottom');
    }
  };

  setHostRef = ref => {
    this.hostElement = ref;
  };

  render() {
    const {isLoading, spinnerSize} = this.props;

    return (
      <InfiniteScroll ref={this.setHostRef} style={{height: spinnerSize}}>
        {spinnerSize && isLoading && <Spinner centerAbs centerX centerY size={spinnerSize} />}
      </InfiniteScroll>
    );
  }
}

export default InfiniteScrollComponent;
